@if(property){
<div class="flex flex-row items-center justify-between gap-2 mb-4">
  <app-breadcrumb [items]="breadcrumdItems" />

  <p-button
    severity="contrast"
    variant="outlined"
    (onClick)="onPropertyBookmark()"
    [disabled]="isAnonymousSession"
  >
    @if (property.isBookmarked) {
    <svg-icon
      src="assets/icons/bookmarks-filled.svg"
      svgClass="h-5 w-5 text-blue-500"
    />
    } @else{
    <svg-icon
      src="assets/icons/bookmarks.svg"
      svgClass="h-5 w-5 text-light-300"
    />
    } Bookmark
  </p-button>
</div>

<div class="relative grid-cols-8 grid-rows-2 gap-2 h-[420px] hidden xl:grid">
  <img
    [src]="property.images[0].url"
    [alt]="property.images[0].caption"
    class="col-span-4 row-span-2 rounded-border h-full w-full object-cover cursor-pointer"
    (click)="onShowPhotosGallery()"
  />

  <!--  -->
  @if(property.images[1]){
  <img
    [src]="property.images[1].url"
    [alt]="property.images[1].caption"
    class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
    (click)="onShowPhotosGallery()"
  />
  }

  <!--  -->
  @if (property.images[2]) {
  <img
    [src]="property.images[2].url"
    [alt]="property.images[2].caption"
    class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
    (click)="onShowPhotosGallery()"
  />
  }

  <!--  -->
  @if(property.images[3]){
  <img
    [src]="property.images[3].url"
    [alt]="property.images[3].caption"
    class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
    (click)="onShowPhotosGallery()"
  />
  }

  <!--  -->
  @if (property.images[4]) {
  <img
    [src]="property.images[4].url"
    [alt]="property.images[4].caption"
    class="col-span-2 row-span-1 rounded-border h-full w-full object-cover cursor-pointer"
    (click)="onShowPhotosGallery()"
  />
  }

  <div
    class="absolute -bottom-6 right-4 inline-flex border border-light-150 rounded-3xl py-3 px-6 bg-light-0 h-12 w-fit"
  >
    <div
      class="flex flex-row gap-2 items-center cursor-pointer hover:opacity-60"
      (click)="onShowPhotosGallery()"
    >
      <svg-icon src="assets/icons/image.svg" svgClass="h-5 w-5 text-blue-100" />
      <p class="font-medium text-base text-light-300">
        {{ property.images.length }} photos
      </p>
    </div>

    <!-- Video tour -->
    @if (property.videoTour) {
    <p-divider layout="vertical" styleClass="h-full m-4" />

    <div
      class="flex flex-row gap-2 items-center cursor-pointer hover:opacity-60"
      (click)="onShowContentViewer(property.videoTour)"
    >
      <svg-icon src="assets/icons/play.svg" svgClass="h-5 w-5 text-blue-100" />

      <p class="font-medium text-base text-light-300">Video tour</p>
    </div>
    }

    <!-- Virtual tour -->
    @if (property.virtualTour) {
    <p-divider layout="vertical" styleClass="h-full m-4" />

    <div
      class="flex flex-row gap-2 items-center cursor-pointer hover:opacity-60"
      (click)="onShowContentViewer(property.virtualTour)"
    >
      <svg-icon
        src="assets/icons/virtual-tour.svg"
        svgClass="h-5 w-5 text-blue-100"
      />

      <p class="font-medium text-base text-light-300">Virtual tour</p>
    </div>
    }
  </div>
</div>

<div class="relative w-full flex flex-col items-center">
  <div
    class="relative z-30 rounded-border overflow-hidden block xl:hidden"
    (click)="onShowPhotosGallery()"
  >
    <p-carousel
      [value]="property.images"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="false"
      [showNavigators]="true"
      [showIndicators]="true"
      styleClass="seedio-carousel"
    >
      <ng-template let-item #item>
        <img
          [src]="item.url"
          [alt]="item.caption"
          class="w-full rounded-border h-[320px]"
        />
      </ng-template>
    </p-carousel>
  </div>

  <div class="xl:hidden block w-[95%] sm:w-[90%] relative -top-10 z-40">
    <p-card
      [style]="{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        padding: '0px',
      }"
    >
      <div class="flex flex-col gap-4">
        <div
          class="inline-flex p-4 bg-light-0 h-12 items-center justify-center w-full"
        >
          <div
            class="flex flex-row gap-2 items-center justify-center cursor-pointer hover:opacity-60"
            [ngClass]="{
              'w-full': !(property.videoTour || property.virtualTour),
              'w-1/2':
                (property.videoTour || property.virtualTour) &&
                !(property.videoTour && property.virtualTour),
              'w-1/3': property.videoTour && property.virtualTour
            }"
            (click)="onShowPhotosGallery()"
          >
            <svg-icon
              src="assets/icons/image.svg"
              svgClass="h-5 w-5 text-blue-100"
            />
            <p class="font-medium text-base text-light-300">
              {{ property.images.length }} photos
            </p>
          </div>

          <!-- Video tour -->
          @if (property.videoTour) {
          <p-divider layout="vertical" styleClass="h-full m-4" />

          <div
            class="flex flex-row w-1/2 gap-2 items-center justify-center cursor-pointer hover:opacity-60"
            [ngClass]="{
              'w-1/2':
                (property.videoTour || property.virtualTour) &&
                !(property.videoTour && property.virtualTour),
              'w-1/3': property.videoTour && property.virtualTour
            }"
            (click)="onShowContentViewer(property.videoTour)"
          >
            <svg-icon
              src="assets/icons/play.svg"
              svgClass="h-5 w-5 text-blue-100"
            />

            <p class="font-medium text-base text-light-300">Video tour</p>
          </div>
          }

          <!-- Virtual tour -->
          @if (property.virtualTour) {
          <p-divider layout="vertical" styleClass="h-full m-4" />

          <div
            class="flex flex-row gap-2 items-center justify-center cursor-pointer hover:opacity-60"
            [ngClass]="{
              'w-1/2':
                (property.videoTour || property.virtualTour) &&
                !(property.videoTour && property.virtualTour),
              'w-1/3': property.videoTour && property.virtualTour
            }"
            (click)="onShowContentViewer(property.virtualTour)"
          >
            <svg-icon
              src="assets/icons/virtual-tour.svg"
              svgClass="h-5 w-5 text-blue-100"
            />

            <p class="font-medium text-base text-light-300">Virtual tour</p>
          </div>
          }
        </div>

        <div class="flex flex-col gap-2">
          <p class="font-medium text-base text-light-100 text-center">
            Property price
          </p>

          <p class="text-center font-bold text-4xl text-blue-100">
            <span class="text-2xl">{{ currency }}</span>
            {{ property.price | number }}
          </p>
        </div>

        <div>
          <p-progressbar
            [style]="{ height: '8px' }"
            [value]="property.totalInvestedPercentage"
            [showValue]="false"
            styleClass="mb-2"
          />

          <div class="flex flex-row items-center justify-between mb-2">
            <p class="font-medium text-sm text-light-100">
              {{ property.totalInvestedPercentage | number : "1.2-2" }}% funded
            </p>

            @if(property.investementStatus === InvestementStatus.AVAILABLE){
            <div class="inline-flex items-center gap-1">
              <p class="font-medium text-sm text-light-100">
                {{
                  property.price - property.totalInvested
                    | customCurrency : currency
                }}
                available
              </p>

              <svg-icon
                src="assets/icons/info.svg"
                svgClass="h-4 w-4 text-light-100 cursor-pointer"
                (click)="isTouchDevice && info.toggle($event)"
                (mouseenter)="!isTouchDevice && info.show($event)"
                (mouseleave)="!isTouchDevice && info.hide()"
              />

              <p-popover #info>
                <p class="w-56 text-light-0 text-base">
                  The available amount comprises the full investment including
                  all related costs as detailed in the Financial section
                </p>
              </p-popover>
            </div>
            }
          </div>
        </div>

        <div class="flex flex-row items-center justify-between gap-2">
          <p class="text-base">
            <span class="font-bold text-blue-100">
              {{ property.numberOfInvestors }}
            </span>
            <span class="text-light-100"> investors</span>
          </p>

          <div
            class="flex flex-row gap-2 items-center border border-light-180 px-2 py-0.5 rounded-4xl"
          >
            <p class="font-bold text-sm text-light-200 leading-5">
              {{
                property.annualRent! / property.area!
                  | customCurrency : currency
              }}
            </p>

            <p class="font-semibold text-xs text-light-100">/ Sq. meter</p>
          </div>
        </div>

        @switch (property.investementStatus) {
        <!-- AVAILABLE -->
        @case (InvestementStatus.AVAILABLE) {
        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base mt-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">5 year total return</p>
            <p class="font-bold text-light-300">
              {{ property.totalReturnPercentage | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Yearly investment return</p>
            <p class="text-light-300 font-bold">
              {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Projected net yield</p>
            <p class="text-light-300 font-bold">
              {{ property.netYieldPercentage | number : "1.2-2" }}%
            </p>
          </div>
        </div>

        }
        <!-- FUNDED -->
        @case (InvestementStatus.FUNDED) {
        <div class="flex flex-row gap-2 items-center text-red-100">
          <svg-icon src="assets/icons/clock.svg" svgClass="h-5 w-5" />
          <p>Closed on {{ property.fundedDate | date }}</p>
        </div>

        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base mt-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Yearly investment return</p>
            <p class="text-light-300 font-bold">
              {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Funded date</p>
            <p class="font-bold text-light-300">
              {{ property.fundedDate | date }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Current valuation</p>
            <p class="text-light-300 font-bold">
              {{ property.latestValuation | customCurrency : currency }}
            </p>
          </div>
        </div>
        }
        <!-- EXITED -->
        @case (InvestementStatus.EXITED) {
        <div class="flex flex-row gap-2 items-center text-red-100">
          <svg-icon src="assets/icons/clock.svg" svgClass="h-5 w-5" />
          <p>Closed on {{ property.fundedDate | date }}</p>
        </div>

        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base mt-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Funded date</p>
            <p class="font-bold text-light-300">
              {{ property.fundedDate | date }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Purchase price</p>
            <p class="text-light-300 font-bold">
              {{ property.grossSellPrice | customCurrency : currency }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Total rental income</p>
            <p class="text-light-300 font-bold">
              {{ property.grossTotalRentalIncome | customCurrency : currency }}
            </p>
          </div>
        </div>
        }
        <!--  -->
        }
      </div>
    </p-card>
  </div>
</div>

<div class="flex flex-row mt-0 xl:mt-12 h-fit w-full gap-6">
  <div
    class="grow-[5] shrink basis-0 bg-light-0 rounded-lg p-4 sm:p-6 overflow-hidden"
  >
    <!-- Details -->
    <h2 class="font-bold text-3xl text-light-300 mb-2">
      {{ property.name }} <span class="text-xl text-red-100">(Demo Mode)</span>
    </h2>

    <div class="flex flex-wrap sm:flex-row items-center gap-1 sm:gap-0">
      @if (property.category === categoryEnum.COMMERCIAL) {
      <div class="flex flex-row items-center gap-1">
        <span class="font-semibold text-xs text-light-200"> Commercial </span>
      </div>

      } @else if (property.category === categoryEnum.INDUSTRIAL) {
      <div class="flex flex-row items-center gap-1">
        <span class="font-semibold text-xs text-light-200"> Industrial </span>
      </div>

      } @else if (property.category === categoryEnum.ENERGY) {
      <div class="flex flex-row items-center gap-1">
        <span class="font-semibold text-xs text-light-200"> Energy </span>
      </div>

      } @else if (property.category === categoryEnum.LAND) {
      <div class="flex flex-row items-center gap-1">
        <span class="font-semibold text-xs text-light-200"> Land </span>
      </div>

      } @else if (property.category === categoryEnum.TRANSPORTATION) {
      <div class="flex flex-row items-center gap-1">
        <span class="font-semibold text-xs text-light-200">
          Transportation
        </span>
      </div>

      } @else if (property.category === categoryEnum.RESIDENTIAL) {
      <div class="flex flex-row items-center gap-1">
        <svg-icon
          [src]="'assets/icons/bed.svg'"
          svgClass="h-4 w-4 text-light-100"
        />
        <span class="font-semibold text-xs text-light-200">
          {{ property.numberOfBedrooms }}
        </span>
      </div>
      }

      <p-divider layout="vertical" styleClass="h-1" />
      <div class="flex flex-row items-center gap-1">
        <svg-icon
          [src]="'assets/icons/' + property.state + '.svg'"
          svgClass="inline-flex h-5 w-5 text-light-100"
        />
        <span class="font-semibold text-base text-light-200">
          @switch (property.state) {
          <!-- READY -->
          @case (State.READY) { Ready }

          <!-- CONSTRUCTION -->
          @case (State.CONSTRUCTION) { Construction }

          <!-- RENOVATION -->
          @case (State.RENOVATION) { Renovation }

          <!-- OPERATIONAL -->
          @case (State.OPERATIONAL) { Operational }

          <!-- SOLD -->
          @case (State.SOLD) { Sold }

          <!--  -->
          }
        </span>
      </div>

      <p-divider layout="vertical" styleClass="h-1" />
      <div class="flex flex-row items-center gap-1">
        <svg-icon
          src="assets/icons/area.svg"
          svgClass="inline-flex h-5 w-5 text-light-100"
        />
        <span class="font-semibold text-base text-light-200">
          {{ property.area | number }} Sq. meters
        </span>
      </div>

      <p-divider layout="vertical" styleClass="h-1" />
      <div class="font-semibold text-base text-light-200">
        {{ property.addressCommunity }}
      </div>
    </div>

    <p-divider />

    <div class="flex flex-col gap-4">
      <!-- Location -->
      <div class="flex flex-row gap-2">
        <div class="flex shrink-0 w-8 h-8 overflow-hidden rounded-full">
          <img
            [src]="
              'assets/flags/' +
              (property.country?.shortName | lowercase) +
              '.svg'
            "
            class="w-full h-full text-light-100 object-cover"
            alt="Country Flag"
          />
        </div>

        <div class="flex flex-col gap-2">
          <h3 class="font-bold text-base text-light-300">
            {{ property.city }}, {{ property.country?.name }}
          </h3>
          <p class="text-base text-light-100">
            A mature real estate market with a high return on investment
          </p>
        </div>
      </div>

      <!-- State === OPERATIONAL || Sold -->
      @if(property.state === state.OPERATIONAL || property.state ===
      state.SOLD){
      <div class="flex flex-row gap-2">
        <div>
          <svg-icon
            src="assets/icons/house-rented.svg"
            svgClass="h-8 w-8 text-light-300"
          />
        </div>

        <div class="flex flex-col gap-2">
          <h3 class="font-bold text-base text-light-300">Rented</h3>
          <p class="text-base text-light-100">
            Currently occupied and professionally managed by our team
          </p>
        </div>
      </div>

      <div class="flex flex-row gap-2">
        <div>
          <svg-icon
            src="assets/icons/coins.svg"
            svgClass="h-8 w-8 text-light-300"
          />
        </div>

        <div class="flex flex-col gap-2">
          <h3 class="font-bold text-base text-light-300">
            Current rent is
            {{
              property.annualRent! / 12 | customCurrency : currency : "1.0-0"
            }}
            per month
          </h3>
          <p class="text-base text-light-100">
            Distributed monthly among all investors after standard charges and
            fees
          </p>
        </div>
      </div>
      }

      <div class="flex flex-row gap-2">
        <div>
          <svg-icon
            src="assets/icons/graph.svg"
            svgClass="h-8 w-8 text-light-300"
          />
        </div>

        <div class="flex flex-col gap-2">
          <h3 class="font-bold text-base text-light-300">
            {{ property.grossYieldPercentage | number : "1.2-2" }}% annual gross
            yield
          </h3>
          <p class="text-base text-light-100">
            With a net yield of
            {{ property.netYieldPercentage | number : "1.2-2" }}% and a price
            per square meter of
            {{
              property.annualRent! / property.area! | customCurrency : currency
            }}
          </p>
        </div>
      </div>
    </div>

    <p-divider />

    @if (property.investementStatus === InvestementStatus.FUNDED ||
    property.investementStatus === InvestementStatus.EXITED ) {
    <p-message severity="warn">
      <div class="flex flex-row gap-2 items-center">
        <svg-icon src="assets/icons/info.svg" svgClass="h-5 w-5" />
        <p class="font-medium text-sm">
          All information on this page is from the date that the property closed
          funding.
        </p>
      </div>
    </p-message>
    }

    <!-- How it works -->
    @if (propertyViewPageConfiguration?.howItWorks) {
    <div class="flex flex-col gap-6 py-10 max-w-full overflow-x-auto">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/question-mark-filled.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">How it works</h3>
      </div>

      <div class="flex flex-row gap-4 basis-full shrink w-full overflow-x-auto">
        <!-- Step 1 -->
        <div
          class="flex flex-col gap-1 justify-between border border-light-120 rounded-lg p-3 w-fit min-w-64"
        >
          <div class="flex flex-row items-center gap-2 mb-3">
            <div class="flex flex-col gap-0.5">
              <p class="font-bold text-base text-blue-100">Step 1</p>
              <p class="font-semibold text-base text-light-200">
                Invest in a piece of this property
              </p>
            </div>

            <svg-icon src="assets/images/step-1.svg" />
          </div>

          <div
            class="flex flex-row items-center gap-1 cursor-pointer w-fit"
            (click)="
              showOwnershipDocumentsDialog = !showOwnershipDocumentsDialog
            "
          >
            <svg-icon
              src="assets/icons/certificate.svg"
              svgClass="h-5 w-5 text-blue-100"
            />
            <p class="font-semibold text-xs text-blue-150">
              View ownership documents
            </p>
            <svg-icon
              src="assets/icons/chevron.svg"
              svgClass="h-4 w-4 text-blue-150"
            />
          </div>

          <p-dialog
            header="Sample documents"
            [modal]="true"
            [(visible)]="showOwnershipDocumentsDialog"
            [style]="{ width: '25rem' }"
          >
            <div class="flex flex-col gap-2">
              <!-- View sample title deed -->
              <a
                class="flex flex-row gap-1 items-center p-2 border border-light-150 rounded-lg cursor-pointer text-light-200 hover:text-blue-150 hover:underline"
                href="assets/documents/official-sample-title-deed-greece.pdf"
                target="_blank"
              >
                <svg-icon
                  src="assets/icons/link.svg"
                  svgClass="h-5 w-5 text-blue-100"
                />
                <p class="font-normal text-sm">View sample title deed</p>
                <div class="m-auto"></div>
                <svg-icon src="assets/icons/chevron.svg" svgClass="h-4 w-4" />
              </a>

              <!-- View sample share certificate -->
              <a
                class="flex flex-row gap-1 items-center p-2 border border-light-150 rounded-lg cursor-pointer text-light-200 hover:text-blue-150 hover:underline"
                href="assets/documents/sample-share-certificate-greece.pdf"
                target="_blank"
              >
                <svg-icon
                  src="assets/icons/link.svg"
                  svgClass="h-5 w-5 text-blue-100"
                />
                <p class="font-normal text-sm">View sample share certificate</p>
                <div class="m-auto"></div>
                <svg-icon src="assets/icons/chevron.svg" svgClass="h-4 w-4" />
              </a>
            </div>
          </p-dialog>
        </div>

        <!-- Step 2 -->
        <div
          class="flex flex-col gap-1 justify-between border border-light-120 rounded-lg p-3 w-fit min-w-64"
        >
          <div class="flex flex-row items-center gap-2 mb-3">
            <div class="flex flex-col gap-0.5">
              <p class="font-bold text-base text-blue-100">Step 2</p>
              <p class="font-semibold text-base text-light-200">
                Earn monthly rental income
              </p>
            </div>

            <svg-icon src="assets/images/step-2.svg" />
          </div>

          <div class="flex flex-row items-center gap-1 w-fit">
            <svg-icon
              src="assets/icons/certificate.svg"
              svgClass="h-5 w-5 text-blue-100"
            />
            <p class="font-semibold text-xs text-blue-150">
              We manage everything for you
            </p>
          </div>
        </div>

        <!-- Step 3 -->
        <div
          class="flex flex-col gap-1 justify-between border border-light-120 rounded-lg p-3 w-fit min-w-64"
        >
          <div class="flex flex-row items-center gap-2 mb-3">
            <div class="flex flex-col gap-0.5">
              <p class="font-bold text-base text-blue-100">Step 3</p>
              <p class="font-semibold text-base text-light-200">
                Watch your investment grow
              </p>
            </div>

            <svg-icon src="assets/images/step-1.svg" />
          </div>

          <div class="flex flex-row items-center gap-1 w-fit">
            <svg-icon
              src="assets/icons/certificate.svg"
              svgClass="h-5 w-5 text-blue-100"
            />
            <p class="font-semibold text-xs text-blue-150">
              Gain from value appreciation
            </p>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Investement strategy -->
    @if (propertyViewPageConfiguration?.investmentStrategy) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/stars-2.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">
          Investment strategy
        </h3>
      </div>

      <div
        class="rounded-lg"
        [ngClass]="{
          'bg-orange-100':
            property.investmentStrategy?.type ===
            InvestmentStrategyTypeEnum.BALANCED,
          'bg-green-160':
            property.investmentStrategy?.type ===
            InvestmentStrategyTypeEnum.CAPITAL_GROWTH,
          'bg-purple-100':
            property.investmentStrategy?.type ===
            InvestmentStrategyTypeEnum.FIX_N_FLIP,
          'bg-blue-700':
            property.investmentStrategy?.type ===
            InvestmentStrategyTypeEnum.HIGH_YIELD,
          'bg-yellow-100':
            property.investmentStrategy?.type ===
            InvestmentStrategyTypeEnum.GOLDEN_VISA
        }"
      >
        <div class="flex flex-col gap-4 p-4">
          <div class="flex flex-row gap-2 items-center justify-between px-2">
            <div class="flex flex-col gap-2 rounded-2xl">
              <h2 class="font-bold text-xl text-light-300">
                {{ property.investmentStrategy?.name }}
              </h2>

              <p class="text-base text-light-300">
                {{ property.investmentStrategy?.description }}
              </p>
            </div>
            <div
              class="flex items-center justify-between w-fit h-fit rounded-full p-2"
              [ngClass]="{
                'bg-orange-800':
                  property.investmentStrategy?.type ===
                  InvestmentStrategyTypeEnum.BALANCED,
                'bg-green-170':
                  property.investmentStrategy?.type ===
                  InvestmentStrategyTypeEnum.CAPITAL_GROWTH,
                'bg-purple-200':
                  property.investmentStrategy?.type ===
                  InvestmentStrategyTypeEnum.FIX_N_FLIP,
                'bg-blue-800':
                  property.investmentStrategy?.type ===
                  InvestmentStrategyTypeEnum.HIGH_YIELD,
                'bg-yellow-200':
                  property.investmentStrategy?.type ===
                  InvestmentStrategyTypeEnum.GOLDEN_VISA
              }"
            >
              <svg-icon
                [src]="
                  'assets/icons/' + property.investmentStrategy?.type + '.svg'
                "
                svgClass="h-10 w-10"
              />
            </div>
          </div>

          <ul class="bg-light-0 p-4 rounded-2xl">
            @for (highlight of property.investmentStrategy?.highlights; track
            $index) {
            <li class="">
              <h3 class="font-semibold text-lg text-light-300">
                {{ highlight.title }}
              </h3>

              <p class="text-base text-light-100">
                {{ highlight.description }}
              </p>

              @if (!$last) {
              <p-divider />
              }
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
    }

    <!-- Investement calculator -->
    @if (propertyViewPageConfiguration?.investmentCalculator) {
    <app-investment-calculator
      [currency]="currency"
      [netYieldPercentage]="property.netYieldPercentage"
    />
    }

    <!-- Property overview -->
    @if (propertyViewPageConfiguration?.propertyOverview) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/house-smart.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">
          Property Overview
        </h3>
      </div>

      <p class="font-normal text-base text-light-300">
        <span
          [innerHTML]="
            isDescriptionExpanded
              ? property.description
              : property.description?.slice(0, DESCIPRION_SHOW_LESS_LIMIT) +
                '...'
          "
        ></span>

        <a
          class="font-bold text-blue-100 hover:underline cursor-pointer mx-1"
          (click)="isDescriptionExpanded = !isDescriptionExpanded"
          >{{ isDescriptionExpanded ? "show less" : "show more" }}
        </a>
      </p>
    </div>
    }

    <!-- Renovations -->
    @if (propertyViewPageConfiguration?.renovations) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/hammer.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Renovations</h3>
      </div>

      <div class="flex flex-col gap-4 border border-light-120 rounded-lg p-5">
        <div class="flex flex-row gap-2 items-center">
          <svg-icon
            src="assets/icons/target.svg"
            svgClass="h-6 w-6 text-blue-150"
          />

          <h4 class="font-semibold text-xl text-light-300">Renovation scope</h4>
        </div>

        <p
          class="text-base text-light-100"
          [innerHTML]="property.renovationScope?.description"
        ></p>

        <div class="flex flex-row gap-2">
          <div
            class="flex flex-row gap-2 items-center justify-center grow bg-light-50 rounded-lg p-2.5 border border-light-120"
          >
            <svg-icon
              src="assets/icons/calendar-dots.svg"
              svgClass="w-4 h-4 text-blue-150"
            />

            <p class="font-semibold text-base text-light-300">
              {{ property.renovationScope?.renovationDurationMinMonths }} -
              {{ property.renovationScope?.renovationDurationMaxMonths }}
              months
            </p>
          </div>

          <div
            class="flex flex-row gap-2 items-center justify-center grow bg-light-50 rounded-lg p-2.5 border border-light-120"
          >
            <svg-icon
              src="assets/icons/calendar-dots.svg"
              svgClass="w-4 h-4 text-blue-150"
            />

            <p class="font-semibold text-base text-light-300">
              {{
                property.renovationScope?.renovationBudget
                  | customCurrency : currency : "1.0-0"
              }}
            </p>
          </div>
        </div>

        <p-divider class="m-0! my-2!" />

        <div
          class="flex flex-row gap-2 items-center justify-center grow bg-blue-160 rounded-lg p-2.5 border border-light-120"
        >
          <div
            class="flex shrink-0 items-center justify-center w-6 h-6 bg-blue-170 rounded-full"
          >
            <div
              class="flex items-center justify-center w-4 h-4 bg-blue-150 rounded-full"
            >
              <svg-icon
                src="assets/icons/check.svg"
                svgClass="w-3 h-3 text-light-0"
              />
            </div>
          </div>

          <p class="font-semibold text-base text-blue-400">
            Approvals will be obtained before renovations
          </p>
        </div>
      </div>
    </div>
    }

    <!-- Leasing strategy -->
    @if (propertyViewPageConfiguration?.leasingStrategy) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/key.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Leasing strategy</h3>
      </div>

      @if (property.rentalType === RentalType.HOLIDAY_RENTAL) {
      <div class="border border-light-120 rounded-lg p-5">
        <div class="flex flex-col gap-3">
          <div class="flex flex-row gap-2 items-center">
            <svg-icon
              src="assets/icons/palm-tree.svg"
              svgClass="h-6 w-6 text-blue-150"
            />

            <h4 class="font-semibold text-xl text-light-300">Holiday home</h4>
          </div>

          <p class="text-base text-light-100">
            This property’s leasing strategy is to rent out on a short term
            basis. It is listed on all the major booking channels.
          </p>
        </div>

        <p-divider />

        <div class="flex flex-col gap-2">
          <h5 class="font-medium text-base text-light-300">Property status</h5>

          <span class="font-medium text-xl text-blue-400"
            >Listed on booking channels</span
          >
          <p class="text-base text-light-100">
            This property is available for bookings on Airbnb and other major
            rental sites.
          </p>

          <p-divider />

          <h5 class="font-medium text-base text-light-300">
            Expected annual rent
          </h5>

          <span class="font-medium text-xl text-blue-400">
            {{ property.annualRent | customCurrency : currency : "1.0-0" }}
          </span>

          <div class="flex flex-row gap-1 items-center text-blue-150">
            <svg-icon src="assets/icons/coins-2.svg" svgClass="h-5 w-5" />
            <p class="font-semibold text-sm">
              Seedio has paid {{ currency }} 29M+ in rent since 2025
            </p>
          </div>
        </div>
      </div>
      } @else {
      <div class="border border-light-120 rounded-lg p-5">
        <div class="flex flex-col gap-3">
          <div class="flex flex-row gap-2 items-center">
            <svg-icon
              src="assets/icons/house-2.svg"
              svgClass="h-6 w-6 text-blue-150"
            />

            <h4 class="font-semibold text-xl text-light-300">
              Long term rental
            </h4>
          </div>

          <p class="text-base text-light-100">
            This property's leasing strategy is to generate consistent monthly
            income through annual contracts with long term tenants.
          </p>
        </div>

        <p-divider />

        <div class="flex flex-col gap-2">
          <h5 class="font-medium text-base text-light-300">Property status</h5>

          @if (property.state === State.OPERATIONAL || property.state ===
          State.SOLD) {
          <span class="font-medium text-xl text-blue-400">Rented</span>
          <p class="text-base text-light-100">
            This property is rented and will start paying rent once transfer is
            complete.
          </p>
          } @else {
          <span class="font-medium text-xl text-light-100">Ready for rent</span>
          <p class="text-base text-light-100">
            This property is vacant and we will be actively searching for a
            tenant after the transfer of title deed.
          </p>
          }

          <p-divider />

          @if (property.state === State.OPERATIONAL || property.state ===
          State.SOLD) {
          <h5 class="font-medium text-base text-light-300">
            Projected annual rent
          </h5>
          } @else {
          <h5 class="font-medium text-base text-light-300">
            Expected annual rent
          </h5>
          }

          <span class="font-medium text-xl text-blue-400">
            {{ property.annualRent | customCurrency : currency : "1.0-0" }}
          </span>

          <div class="flex flex-row gap-1 items-center text-blue-150">
            <svg-icon src="assets/icons/coins-2.svg" svgClass="h-5 w-5" />
            <p class="font-semibold text-sm">
              Seedio has paid {{ currency }} 29M+ in rent since 2025
            </p>
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- Financials Generic -->
    @if (propertyViewPageConfiguration?.financialsGeneric) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/coins-2.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Financials</h3>
      </div>

      <app-tablist
        [tabs]="['Property cost', 'Rental income (Year 1)']"
        [activeTab]="activeFinancialsTab"
        (activeTabChange)="activeFinancialsTab = $event"
      />

      @switch (activeFinancialsTab) {
      <!--  -->
      @case (FinancialsTab.PROPERTY_COST) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Property price </span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            {{ property.price | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverPP.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverPP.show($event)"
            (mouseleave)="!isTouchDevice && popoverPP.hide()"
          />

          <p-popover #popoverPP>
            <p class="w-56 text-light-0 text-base">
              The amount paid to acquire the property, reflecting its market
              value at the time of purchase.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Transaction costs </span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            + {{ property.transactionCost | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverTC.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverTC.show($event)"
            (mouseleave)="!isTouchDevice && popoverTC.hide()"
          />

          <p-popover #popoverTC>
            <p class="w-56 text-light-0 text-base">
              Fees associated with buying the property, including legal fees,
              transfer fees, and any taxes or charges related to the
              transaction.
            </p>
          </p-popover>
        </div>

        <p-divider styleClass="m-0! my-1!" />

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Investment cost</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-blue-100">
            =
            {{ property.investmentCost | number }} {{ currency }}
          </span>

          <div class="w-4 h-4"></div>
          <div></div>
        </div>

        <div
          class="flex flex-row items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
        >
          <p class="font-medium text-xs text-light-100">
            Includes Seedio's 1.5% fee
          </p>
        </div>
      </div>
      }
      <!--  -->
      @case (FinancialsTab.INCOME_YEAR_1) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Annual gross rent</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            {{ property.annualRent | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverGR.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverGR.show($event)"
            (mouseleave)="!isTouchDevice && popoverGR.hide()"
          />

          <p-popover #popoverGR>
            <p class="w-40 text-light-0 text-base">Annual gross rent</p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Service charges</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            - {{ property.annualServiceCharges | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverSC.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverSC.show($event)"
            (mouseleave)="!isTouchDevice && popoverSC.hide()"
          />

          <p-popover #popoverSC>
            <p class="w-72 text-light-0 text-base">
              The fees associated with the upkeep of common areas and facilities
              in the property, such as security, cleaning, and landscaping,
              typilcally charged by the building or community management.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100"
            >Management and maintenance</span
          >
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            - {{ property.annualManagementMaintenance | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverMM.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverMM.show($event)"
            (mouseleave)="!isTouchDevice && popoverMM.hide()"
          />

          <p-popover #popoverMM>
            <p class="w-72 text-light-0 text-base">
              The costs incurred for the day-to-day management of the property
              and its upkeep, including tenant services, repairs, and routine
              maintenance, ensuring the property remains in good condition.
            </p>
          </p-popover>
        </div>

        <p-divider styleClass="m-0! my-1!" />

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Annual net income</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-blue-100">
            =
            {{ property.netIncome | number }} {{ currency }}
          </span>

          <div class="w-4 h-4"></div>
          <div></div>
        </div>

        <div
          class="flex flex-row gap-2 items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
        >
          <p class="font-medium text-xs text-light-100 text-center">
            This is an estimate for the 1st year of ownership
          </p>

          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverE.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverE.show($event)"
            (mouseleave)="!isTouchDevice && popoverE.hide()"
          />

          <p-popover #popoverE>
            <p class="w-72 text-light-0 text-base">
              This rental income breakown is based on estimated rental income,
              decuctions, and fees for the first year of ownership only. Please
              note that actual rental income, deductions, and fees may vary
              based on market conditions and future rental terms.
            </p>
          </p-popover>
        </div>
      </div>
      }
      <!--  -->
      }
    </div>
    }

    <!-- Financials For Renovations -->
    @if (propertyViewPageConfiguration?.financialsRenovation) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/coins-2.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Financials</h3>
      </div>

      <div
        class="flex flex-row gap-2 items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
      >
        <p class="font-medium text-xs text-light-100 text-center">
          Appreciation-focused with no rental income
        </p>

        <svg-icon
          src="assets/icons/question-mark.svg"
          svgClass="w-4 h-4 text-light-100"
          (click)="isTouchDevice && popoverA.toggle($event)"
          (mouseenter)="!isTouchDevice && popoverA.show($event)"
          (mouseleave)="!isTouchDevice && popoverA.hide()"
        />

        <p-popover #popoverA>
          <p class="w-72 text-light-0 text-base">
            Flip properties aren't eligible fro rental dividents due to their
            shorter-term investment strategy.
          </p>
        </p-popover>
      </div>

      <app-tablist
        [tabs]="['Investment cost', 'Expected exit price']"
        [activeTab]="activeFinancialsTab"
        (activeTabChange)="activeFinancialsTab = $event"
      />

      @switch (activeFinancialsTab) {
      <!-- Investment cost  -->
      @case (FinancialsTab.PROPERTY_COST) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Property price </span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            {{ property.price | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverPP.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverPP.show($event)"
            (mouseleave)="!isTouchDevice && popoverPP.hide()"
          />

          <p-popover #popoverPP>
            <p class="w-72 text-light-0 text-base">
              The amount paid to acquire the property, reflecting its market
              value at the time of purchase.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Transaction costs </span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            + {{ property.transactionCost | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverTC.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverTC.show($event)"
            (mouseleave)="!isTouchDevice && popoverTC.hide()"
          />

          <p-popover #popoverTC>
            <p class="w-72 text-light-0 text-base">
              Fees associated with buying the property, including legal fees,
              transfer fees, and any taxes or charges related to the
              transaction.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Renovation budget</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            + {{ property.renovationScope?.renovationBudget | number }}
            {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverRB.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverRB.show($event)"
            (mouseleave)="!isTouchDevice && popoverRB.hide()"
          />

          <p-popover #popoverRB>
            <p class="w-72 text-light-0 text-base">
              The estimated cost for property renovations, including a buffer to
              cover unexpected expense during the process.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Operational budget</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            + {{ property.renovationScope?.operationalBudget | number }}
            {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverOB.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverOB.show($event)"
            (mouseleave)="!isTouchDevice && popoverOB.hide()"
          />

          <p-popover #popoverOB>
            <p class="w-72 text-light-0 text-base">
              The funds allocated for managing the property during the
              investment period, including service charges.
            </p>
          </p-popover>
        </div>

        <p-divider styleClass="m-0! my-1!" />

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Investment cost</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-blue-100">
            =
            {{ property.investmentCost | number }} {{ currency }}
          </span>

          <div class="w-4 h-4"></div>
          <div></div>
        </div>

        <div
          class="flex flex-row items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
        >
          <p class="font-medium text-xs text-light-100">
            Includes Seedio's 1.5% fee
          </p>
        </div>
      </div>
      }
      <!-- Expected exit price -->
      @case (FinancialsTab.INCOME_YEAR_1) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Investment cost</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            {{ property.investmentCost | number }} {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverIC.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverIC.show($event)"
            (mouseleave)="!isTouchDevice && popoverIC.hide()"
          />

          <p-popover #popoverIC>
            <p class="w-72 text-light-0 text-base">
              The total amount spent on purchasing, renovating, and managing the
              property, including all fees and budgets.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Appreciation</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            + {{ property.renovationScope?.projectedAppreciation | number }}
            {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverPA.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverPA.show($event)"
            (mouseleave)="!isTouchDevice && popoverPA.hide()"
          />

          <p-popover #popoverPA>
            <p class="w-72 text-light-0 text-base">
              The estimated increase in the investment value overtime, based on
              market trends and improvements made during the renovation.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Unutilised funds</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            +
            {{ property.renovationScope?.projectedUnutilisedFunds | number }}
            {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverUF.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverUF.show($event)"
            (mouseleave)="!isTouchDevice && popoverUF.hide()"
          />

          <p-popover #popoverUF>
            <p class="w-72 text-light-0 text-base">
              This may or may not include funds from unutillised renovation
              budget or operational reserve and/or supplemental rental income
              from short-stay bookings.
            </p>
          </p-popover>
        </div>

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Exit costs</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-light-300">
            -
            {{ property.renovationScope?.projectedExitCostsWithVat | number }}
            {{ currency }}
          </span>
          <svg-icon
            src="assets/icons/question-mark.svg"
            svgClass="w-4 h-4 text-light-100"
            (click)="isTouchDevice && popoverEC.toggle($event)"
            (mouseenter)="!isTouchDevice && popoverEC.show($event)"
            (mouseleave)="!isTouchDevice && popoverEC.hide()"
          />

          <p-popover #popoverEC>
            <p class="w-72 text-light-0 text-base">
              Fees for selling the property, including brokeage fees, SPV
              liquidation costs, and Seedio's exit and performance fees.
            </p>
          </p-popover>
        </div>

        <p-divider styleClass="m-0! my-1!" />

        <div class="flex flex-row gap-2 items-center">
          <span class="text-base text-light-100">Expected exit price</span>
          <div class="m-auto"></div>
          <span class="font-extrabold text-base text-blue-100">
            =
            {{ property.renovationScope?.projectedExitPrice | number }}
            {{ currency }}
          </span>

          <div class="w-4 h-4"></div>
          <div></div>
        </div>

        <div
          class="flex flex-row gap-2 items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
        >
          <p class="font-medium text-xs text-light-100 text-center">
            Projections assume minimum no. of months to sell
          </p>
        </div>
      </div>
      }
      <!--  -->
      }
    </div>
    }

    <!-- Funding timeline -->
    @if (propertyViewPageConfiguration?.funingTimeline) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/calendar.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Funding timeline</h3>
      </div>

      <app-timeline [timeline]="property.fundingTimelineComponent!" />
    </div>
    }

    <!-- Location  -->
    @if (propertyViewPageConfiguration?.location) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/pointer.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">Location</h3>
      </div>

      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/pointer-2.svg"
          svgClass="w-6 h-4 text-blue-100"
        />
        <a
          class="font-semibold text-base text-light-200 hover:text-blue-150 hover:underline"
          [href]="googleMapsUrl"
          target="_blank"
          >{{ markerTitle }}</a
        >
      </div>

      <div class="rounded-lg w-full h-[400px] overflow-hidden">
        <google-map
          height="100%"
          width="100%"
          [center]="markerPosition"
          [zoom]="zoom"
          [options]="mapOptions"
        >
          <map-marker
            [position]="markerPosition"
            [title]="markerTitle"
            (mapClick)="openGoogleMaps()"
          />
        </google-map>
      </div>

      <p class="text-base text-light-300">
        {{ property.neighbourhood?.description }}
      </p>
    </div>
    }

    <!-- Documents -->
    @if (propertyViewPageConfiguration?.documents) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <svg-icon
          src="assets/icons/documents.svg"
          svgClass="h-6 w-6 text-light-300"
        />

        <h3 class="font-extrabold text-2xl text-light-300">
          Documents <span>({{ property.documents?.length || 0 }})</span>
        </h3>
      </div>

      <ul class="flex flex-col gap-6">
        @for (document of property.documents; track $index) {
        <a
          class="flex flex-row gap-4 items-center justify-between p-4 border-[1.5px] text-light-300 border-light-150 rounded-lg cursor-pointer hover:bg-light-150 hover:text-blue-150 hover:underline"
          [href]="document.url"
          target="_blank"
        >
          <div class="flex flex-row gap-2 items-center pointer-events-none">
            <svg-icon
              [src]="'assets/icons/' + document.type + '.svg'"
              svgClass="h-6 w-6"
            />
            <p class="text-sm">
              {{ document.name }}
            </p>
          </div>

          <svg-icon
            [src]="'assets/icons/download.svg'"
            svgClass="h-5 w-5 text-blue-100"
            (click)="onDownloadDocument($index, $event)"
          />
        </a>
        }
      </ul>
    </div>
    }

    <!-- More questions -->
    @if (propertyViewPageConfiguration?.moreQuestions) {
    <div class="flex flex-col gap-6 py-10">
      <div class="flex flex-row items-center gap-2">
        <h3 class="font-extrabold text-2xl text-light-300">
          Have more questions about this property?
        </h3>
      </div>

      <div class="flex flex-col gap-2">
        <p class="text-base">Contact our real estate experts</p>

        <p-button
          severity="contrast"
          variant="outlined"
          size="large"
          (onClick)="onSendMessage()"
        >
          <svg-icon
            src="assets/icons/message-us.svg"
            svgClass="h-5 w-5 text-blue-500"
          />

          Message us
        </p-button>
      </div>
    </div>
    }
  </div>

  <div
    class="sticky top-0 hidden xl:block lg:max-w-[430px] h-fit min-w-[400px]"
  >
    <p-card
      [style]="{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        padding: '16px',
      }"
    >
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <p class="font-medium text-base text-light-100 text-center">
            Property price
          </p>

          <p class="text-center font-bold text-4xl text-blue-100">
            <span class="text-2xl">{{ currency }}</span>
            {{ property.price | number }}
          </p>
        </div>

        <div>
          <p-progressbar
            [style]="{ height: '8px' }"
            [value]="property.totalInvestedPercentage"
            [showValue]="false"
            styleClass="mb-2"
          />

          <div class="flex flex-row items-center justify-between mb-2">
            <p class="font-medium text-sm text-light-100">
              {{ property.totalInvestedPercentage | number : "1.2-2" }}% funded
            </p>

            @if(property.investementStatus === InvestementStatus.AVAILABLE){
            <div class="inline-flex items-center gap-1">
              <p class="font-medium text-sm text-light-100">
                {{
                  property.price - property.totalInvested
                    | customCurrency : currency
                }}
                available
              </p>

              <svg-icon
                src="assets/icons/info.svg"
                svgClass="h-4 w-4 text-light-100 cursor-pointer"
                (click)="isTouchDevice && info.toggle($event)"
                (mouseenter)="!isTouchDevice && info.show($event)"
                (mouseleave)="!isTouchDevice && info.hide()"
              />

              <p-popover #info>
                <p class="w-56 text-light-0 text-base">
                  The available amount comprises the full investment including
                  all related costs as detailed in the Financial section
                </p>
              </p-popover>
            </div>
            }
          </div>
        </div>

        <div class="flex flex-row items-center justify-between gap-2">
          <p class="text-base">
            <span class="font-bold text-blue-100">
              {{ property.numberOfInvestors }}
            </span>
            <span class="text-light-100"> investors</span>
          </p>

          <div
            class="flex flex-row gap-2 items-center border border-light-180 px-2 py-0.5 rounded-4xl"
          >
            <p class="font-bold text-sm text-light-200 leading-5">
              {{
                property.annualRent! / property.area!
                  | customCurrency : currency
              }}
            </p>

            <p class="font-semibold text-xs text-light-100">/ Sq. meter</p>
          </div>
        </div>

        @switch (property.investementStatus) {
        <!-- AVAILABLE -->
        @case (InvestementStatus.AVAILABLE) {
        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base my-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">5 year total return</p>
            <p class="font-bold text-light-300">
              {{ property.totalReturnPercentage | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Yearly investment return</p>
            <p class="text-light-300 font-bold">
              {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Projected net yield</p>
            <p class="text-light-300 font-bold">
              {{ property.netYieldPercentage | number : "1.2-2" }}%
            </p>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <form [formGroup]="form" (ngSubmit)="onAddToCart()">
            <div class="flex flex-row items-center gap-2">
              <p-inputgroup class="h-12.5">
                <p-inputgroup-addon>
                  <div class="flex flex-row items-center gap-1">
                    <!-- <svg-icon
                      [src]="'assets/flags/' + property.country.icon + '.svg'"
                      svgClass="h-4 w-4 text-light-100"
                    /> -->

                    <span class="font-semibold text-sm text-light-300">
                      {{ currency }}
                    </span>
                  </div>
                </p-inputgroup-addon>
                <p-inputnumber
                  formControlName="amount"
                  placeholder="Enter amount"
                  [style]="{
                    'ng-invalid ng-dirty':
                      f['amount'].invalid && f['amount'].touched
                  }"
                />
              </p-inputgroup>

              <p-fluid>
                <p-button
                  severity="primary"
                  type="submit"
                  label="Add to cart"
                  size="large"
                  [disabled]="!form.valid || isAnonymousSession"
                  [fluid]="true"
                />
              </p-fluid>
            </div>
          </form>

          <div class="flex flex-row items-center gap-2">
            <p-fluid>
              <p-button
                severity="success"
                type="submit"
                [label]="'+' + (500 | customCurrency : currency : '1.0-0')"
                size="small"
                [fluid]="true"
                (onClick)="onAddAmount(500)"
              />
            </p-fluid>

            <p-fluid>
              <p-button
                severity="success"
                type="submit"
                [label]="'+' + (1000 | customCurrency : currency : '1.0-0')"
                size="small"
                [fluid]="true"
                (onClick)="onAddAmount(1000)"
              />
            </p-fluid>

            <p-fluid>
              <p-button
                severity="success"
                type="submit"
                [label]="'+' + (5000 | customCurrency : currency : '1.0-0')"
                size="small"
                [fluid]="true"
                (onClick)="onAddAmount(5000)"
              />
            </p-fluid>
          </div>

          @if(f['amount'].invalid && f['amount'].touched) {
          <p
            class="flex flex-row gap-2 items-center font-semibold text-xs text-red-100"
          >
            <svg-icon
              src="assets/icons/warning.svg"
              svgClass="h-4 w-4 text-red-100"
            />

            <!-- Error: Required -->
            @if ( f['amount'].errors?.['required']) { Minimum investment is
            {{ MINIMUM_AMOUNT | customCurrency : currency : "1.0-0" }} }

            <!-- Error: Min -->
            @if (f['amount'].errors?.['min']) { Minimum investment is
            {{ MINIMUM_AMOUNT | customCurrency : currency : "1.0-0" }} }

            <!-- Error: Max -->
            @if (f['amount'].errors?.['max']){ Maximum investment is
            {{ MAXIMUM_AMOUNT | customCurrency : currency : "1.0-0" }} }
          </p>
          }

          <p class="font-medium text-sm text-light-100 text-center">
            You won't be charged yet
          </p>
        </div>

        }
        <!-- FUNDED -->
        @case (InvestementStatus.FUNDED) {
        <div class="flex flex-row gap-2 items-center text-red-100">
          <svg-icon src="assets/icons/clock.svg" svgClass="h-5 w-5" />
          <p>Closed on {{ property.fundedDate | date }}</p>
        </div>

        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base my-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Yearly investment return</p>
            <p class="text-light-300 font-bold">
              {{ property.totalReturnPercentage / 5 | number : "1.2-2" }}%
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Funded date</p>
            <p class="font-bold text-light-300">
              {{ property.fundedDate | date }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Current valuation</p>
            <p class="text-light-300 font-bold">
              {{ property.latestValuation | customCurrency : currency }}
            </p>
          </div>
        </div>
        }
        <!-- EXITED -->
        @case (InvestementStatus.EXITED) {
        <div class="flex flex-row gap-2 items-center text-red-100">
          <svg-icon src="assets/icons/clock.svg" svgClass="h-5 w-5" />
          <p>Closed on {{ property.fundedDate | date }}</p>
        </div>

        <div
          class="flex flex-col gap-2 p-6 bg-light-50 rounded-lg font-medium text-base my-4"
        >
          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Funded date</p>
            <p class="font-bold text-light-300">
              {{ property.fundedDate | date }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Purchase price</p>
            <p class="text-light-300 font-bold">
              {{ property.grossSellPrice | customCurrency : currency }}
            </p>
          </div>

          <div class="flex flex-row justify-between gap-8">
            <p class="text-light-100">Total rental income</p>
            <p class="text-light-300 font-bold">
              {{ property.grossTotalRentalIncome | customCurrency : currency }}
            </p>
          </div>
        </div>
        }
        <!--  -->
        }
      </div>
    </p-card>

    @if (property.investementStatus === InvestementStatus.AVAILABLE) {
    <div class="flex flex-row items-center justify-center gap-2 mt-4">
      <svg-icon
        src="assets/icons/stars.svg"
        svgClass="h-5 w-5 text-light-100"
      />

      <p class="font-medium text-sm text-light-100 text-center">
        {{ property.totalViews | number }} people viewed this property
      </p>
    </div>
    }
  </div>
</div>

<!-- Similar properties -->
<div></div>

<div class="sticky bottom-0 p-4 bg-light-0 block xl:hidden">
  <form [formGroup]="form" (ngSubmit)="onAddToCart()">
    <div class="flex flex-row items-center gap-2">
      <p-inputgroup class="h-12.5">
        <p-inputgroup-addon>
          <div class="flex flex-row items-center gap-1">
            <!-- <svg-icon
                      [src]="'assets/flags/' + property.country.icon + '.svg'"
                      svgClass="h-4 w-4 text-light-100"
                    /> -->

            <span class="font-semibold text-sm text-light-300">
              {{ currency }}
            </span>
          </div>
        </p-inputgroup-addon>
        <p-inputnumber
          formControlName="amount"
          placeholder="Enter amount"
          [style]="{
            'ng-invalid ng-dirty': f['amount'].invalid && f['amount'].touched
          }"
        />
      </p-inputgroup>

      <p-fluid>
        <p-button
          severity="primary"
          type="submit"
          label="Add to cart"
          size="large"
          [disabled]="!form.valid || isAnonymousSession"
          [fluid]="true"
        />
      </p-fluid>
    </div>
  </form>
</div>
} @else {
<ng-container *ngTemplateOutlet="loadingPropertySkeleton"></ng-container>
}

<ng-template #loadingPropertySkeleton>
  <div class="flex flex-row items-center justify-between gap-2 mb-4">
    <p-skeleton width="400px" height="30px" borderRadius="2" />
    <p-skeleton width="100px" height="41px" borderRadius="2" />
  </div>

  <div class="flex flex-col gap-10">
    <div
      class="relative grid-cols-8 grid-rows-2 gap-2 w-full h-[350px] hidden xl:grid"
    >
      <div class="col-span-4 row-span-2">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div class="col-span-2 row-span-1">
        <p-skeleton width="100%" height="100%" borderRadius="2" />
      </div>

      <div
        class="absolute -bottom-6 right-4 inline-flex border border-light-150 rounded-3xl py-3 px-6 bg-light-0 h-12 w-fit"
      >
        <p-skeleton height="100%" width="100px" borderRadius="8px" />

        <p-divider layout="vertical" styleClass="h-full m-4" />

        <p-skeleton height="100%" width="100px" borderRadius="8px" />
      </div>
    </div>

    <p-skeleton class="block xl:hidden" height="200px" borderRadius="8px" />

    <p-skeleton height="100px" borderRadius="8px" />

    <p-skeleton height="400px" borderRadius="8px" />

    <p-skeleton height="200px" borderRadius="8px" />

    <p-skeleton height="100px" borderRadius="8px" />

    <div class="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-10">
      @for (_ of [1, 2, 3]; track $index) {
      <p-card
        [style]="{
          'min-width': '350px',
          'max-width': '390px',
          height: '100%',
          overflow: 'hidden'
        }"
      >
        <ng-template #header>
          <p-skeleton height="232px" borderRadius="0" />
        </ng-template>

        <div class="flex flex-col justify-between gap-5">
          <p-skeleton height="20px" />
          <p-skeleton height="30px" width="70%" />
          <p-skeleton height="18px" />
          <p-skeleton height="100px" />
        </div>
      </p-card>
      }
    </div>
  </div>
</ng-template>
